import Post from "../api/Post"
import { LOGIN } from "../api/Routes"
import { PASSWORD_COLOMBIA, PASSWORD_MEXICO, USER_COLOMBIA, USER_MEXICO } from '../constants/security'

export const getTokenExternal = async (company = {id: 1}) =>{    
    
    let d = {
        username: company.id === 1 ? USER_MEXICO : USER_COLOMBIA,
        password: company.id === 1 ? PASSWORD_MEXICO : PASSWORD_COLOMBIA
    }
    let token = await Post({url: LOGIN, data: d, header: false})
    return token;
}